export function scrollIntoView(el: HTMLElement, onReached?: () => void) {
  if (onReached) {
    const io = new IntersectionObserver(
      (entries) => {
        const e = entries[0];
        if (e?.isIntersecting && e.intersectionRatio >= 0.8) {
          io.disconnect();
          onReached();
        }
      },
      { threshold: [0.8] }
    );

    io.observe(el);
  }
  el.scrollIntoView({ behavior: "smooth", block: "start" });
}
